import { useCallback, useEffect, useState } from 'react';

import { CoreFormFieldSelect } from '@bambi/component-library/src/components/forms/fields/CoreFormFieldSelect';
import { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { FilterPopover } from 'src/common/primitives/FilterPopover/FilterPopover';

import {
  FilterAllowSMSMessage,
  setFilterAllowSMSMessage,
} from '../passenger.slice';

const options: SelectOption<FilterAllowSMSMessage>[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

interface PassengerSMSColumnFilterProps {
  open: boolean;
  onClose: () => void;
}

export const PassengerSMSColumnFilter = ({
  open,
  onClose,
}: PassengerSMSColumnFilterProps) => {
  const dispatch = useAppDispatch();

  const filterAllowSMSMessage = useAppSelector(
    (state) => state.passenger.filterAllowSMSMessage
  );

  const filteredOption = options.find(
    (option) => option.value === filterAllowSMSMessage
  );

  const [selectedOption, setSelectedOption] = useState<
    SelectOption<FilterAllowSMSMessage>
  >(filteredOption ?? options[0]);

  const handleApply = useCallback(() => {
    dispatch(setFilterAllowSMSMessage(selectedOption.value));
    onClose();
  }, [dispatch, selectedOption, onClose]);

  useEffect(() => {
    setSelectedOption(filteredOption ?? options[0]);
  }, [filteredOption]);

  return (
    <FilterPopover
      open={open}
      triggerElement={<div data-testid="passenger-sms-column-filter-trigger" />}
      onApply={handleApply}
      onCancel={() => {
        onClose();
      }}
    >
      <CoreFormFieldSelect
        label="SMS Enabled?"
        options={options}
        value={selectedOption}
        onChange={setSelectedOption}
      />
    </FilterPopover>
  );
};
